import {post} from '../../request'
/**
 * 用户体现列表
 * @param data
 * @returns {*}
 */
export function userpresentList(data) {
    return post("admin/finance.userpresent/index", data)
}

/**
 * 用户体现列表
 * @param data
 * @returns {*}
 */
export function getZh(data) {
    return post("admin/finance.userpresent/getZh", data)
}


/**
 *审核用户体现
 * @param data
 * @returns {*}
 */
export function shenheUserpresent(data) {
    return post("admin/finance.userpresent/shenhe", data)
}

/**
 *付款
 * @param data
 * @returns {*}
 */
export function fukuanUserpresent(data) {
    return post("admin/finance.userpresent/fukuan", data)
}


/**
 *付款
 * @param data
 * @returns {*}
 */
export function detailUserpresent(data) {
    return post("admin/finance.userpresent/detail", data)
}


/**
 *统计
 * @param data
 * @returns {*}
 */
export function adminStatistics(data) {
    return post("admin/finance.userpresent/adminStatistics", data)
}


/**
 *详情
 * @param data
 * @returns {*}
 */
export function detail(data) {
    return post("admin/finance.userpresent/detail", data)
}